import {
    buildMultilineChartRows,
    MultilineChart,
    MultilineLegend,
} from './multiline-chart';
import { formatDownloadsAxisDate } from './downloads-form.helpers';
import style from './multiline-chart.module.scss';
import type { KpiFormProps } from '../types';

/**
 * Multiline form: N named daily series over an explicit range, drawn as
 * counts or percents with a legend. Delegates the drawing to
 * `MultilineChart`/`MultilineLegend`; `downloads-form` composes the same
 * chart with its own legend and store-lag handling instead.
 */
export const MultilineForm = ({ data, palette, chartStyle }: KpiFormProps) => {
    if (data.form !== 'multiline') return null;
    const rows = buildMultilineChartRows(data.range, data.series);

    return (
        <div className={style.multiline_form}>
            <MultilineChart
                rows={rows}
                series={data.series.map((entry) => ({ label: entry.label }))}
                unit={data.unit}
                chartStyle={chartStyle}
                palette={palette}
            />
            <MultilineLegend
                series={data.series.map((entry) => ({
                    label: entry.label,
                    value: entry.value,
                }))}
                unit={data.unit}
                palette={palette}
            />
            {data.completeThrough !== undefined && (
                <p className={`${style.multiline_note} footnote_description`}>
                    Legend covers {formatDownloadsAxisDate(data.range.start)} –{' '}
                    {formatDownloadsAxisDate(data.completeThrough)}; the period
                    runs to {formatDownloadsAxisDate(data.range.end)}.
                </p>
            )}
        </div>
    );
};
